{
    "Profile_Drivers_CriminalConviction.criminalConviction": "FR: Criminal Conviction",
    "Profile_Drivers_CriminalConviction.criminalConvictionDetails": "FR: Criminal Conviction Details",
    "Profile_Drivers_CriminalConviction.dateOfConviction": "FR: Date of Conviction",
    "Profile_Drivers_CriminalConviction.convictionReason": "FR: Conviction Reason"
}
